{
  "nl": {
    "textExtract": {
      "alerts": {
        "limitReached": "Je hebt je limiet voor tekstextracties bereikt."
      },
      "buttons": {
        "extract": "Tekst extraheren",
        "processing": "Verwerking bezig..."
      },
      "errors": {
        "processingFailed": "De tekstextractie is mislukt. Probeer het opnieuw."
      },
      "inputKinds": {
        "file": {
          "dropTitle": "Sleep het bestand hierheen of {select}",
          "dropTitleSelect": "selecteer",
          "help": "PDF's, afbeeldingen, audiobestanden en gangbare MS-Office-formaten",
          "label": "Bestand",
          "maxSize": "Maximaal {limit} MB",
          "placeholder": "Bestand selecteren",
          "title": "Bestand"
        },
        "audio": {
          "help": "Tip: Je kunt een bestand direct uploaden via drag & drop. We ondersteunen .mp3, .mp4, .mp4a of .wav bestanden tot max. {limit}MB.",
          "icon": "bi-file-music",
          "label": "Audiobestand",
          "placeholder": "Audiobestand selecteren",
          "title": "Audiobestand"
        },
        "image": {
          "help": "Tip: Je kunt een bestand direct uploaden via drag & drop. We ondersteunen .jpeg, .png tot {limit}MB.",
          "icon": "bi-image",
          "label": "Afbeeldingsbestand",
          "placeholder": "Afbeeldingsbestand selecteren",
          "title": "Afbeelding"
        },
        "pdf": {
          "help": "Tip: Je kunt een bestand direct uploaden via drag & drop. We ondersteunen .pdf tot {limit}MB.",
          "icon": "bi-file-earmark-pdf",
          "label": "PDF-bestand",
          "placeholder": "PDF-bestand selecteren",
          "title": "PDF"
        },
        "video": {
          "help": "Tip: Je kunt een bestand direct uploaden via drag & drop. We ondersteunen .mp4, .mp4v, .avi of .mkv bestanden tot max. {limit}MB.",
          "icon": "bi-film",
          "label": "Videobestand",
          "placeholder": "Videobestand selecteren",
          "title": "Videobestand"
        },
        "website": {
          "label": "Webpagina-URL",
          "placeholder": "https://fobizz.com/was-ist-fobizz/",
          "title": "Webpagina"
        },
        "youtube": {
          "label": "YouTube-URL of zoekopdracht",
          "placeholder": "Voer YouTube-URL in of zoek naar video...",
          "title": "YouTube"
        },
        "text": {
          "label": "Tekst",
          "placeholder": "Hier kun je zelf achtergrondkennis toevoegen...",
          "title": "Tekst"
        }
      },
      "labels": {
        "language": "Taal"
      },
      "modal": {
        "title": "Tekst extraheren"
      },
      "sourcePicker": {
        "addNew": "Nieuw toevoegen",
        "recent": "Recent gebruikt"
      },
      "upload": {
        "success": "Bestand succesvol geüpload"
      },
      "options": {
        "languages": {
          "auto": "Automatisch detecteren"
        }
      },
      "youtube": {
        "noResults": "Geen video's gevonden voor je zoekopdracht.",
        "searchError": "Fout bij het zoeken naar video's. Probeer het opnieuw."
      },
      "privacyHint": "Deel geen gevoelige informatie of persoonlijke gegevens van leerlingen met een AI."
    }
  }
}
